import Headroom from 'headroom.js';

const HeaderScroll = () => {
    const header = document.querySelector('header');
    const body = document.querySelector('body');
    const mobileButton = document.querySelector('.header__mobile');

    const updateScrollLock = () => {
        const mobileOpen = document.querySelector('.mobile-menu--active');
        const donateOpen = document.querySelector('.donate-menu__item--active');

        if (mobileOpen || donateOpen) {
            body.classList.add('no-scroll');
        } else {
            body.classList.remove('no-scroll');
        }
    };

    if (mobileButton) {
        mobileButton.addEventListener('click', () => {
            // wait a tick so classes update first
            setTimeout(updateScrollLock, 0);
        });
    }

    // Watch donate menu clicks
    document.addEventListener('click', e => {
        if (e.target.closest('.donate-menu__item--parent')) {
            setTimeout(updateScrollLock, 0);
        }
    });

    var headroom = new Headroom(header);
    headroom.init();
};

export default HeaderScroll;
